import React, { useEffect, useRef, useState } from 'react';

export default function Hero() {
  const [offset, setOffset] = useState(0);
  const [loaded, setLoaded] = useState(false);
  const heroRef = useRef(null);

  useEffect(() => {
    const timer = setTimeout(() => setLoaded(true), 100);
    const onScroll = () => {
      if (heroRef.current) {
        const y = window.scrollY;
        setOffset(y * 0.3);
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => { clearTimeout(timer); window.removeEventListener('scroll', onScroll); };
  }, []);

  const scrollDown = () => document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' });

  return (
    <section id="hero" ref={heroRef} style={{
      height: '100vh', minHeight: 700,
      position: 'relative', overflow: 'hidden',
      display: 'flex', alignItems: 'center',
      paddingTop: 'var(--nav-h)',
    }}>
      <div style={{ position: 'absolute', inset: 0, overflow: 'hidden' }}>
        <video autoPlay muted loop playsInline style={{
          position: 'absolute', inset: 0,
          width: '100%', height: '100%',
          objectFit: 'cover', objectPosition: 'center',
          transform: `translateY(${offset}px)`,
          willChange: 'transform',
        }}>
          <source src="https://videos.pexels.com/video-files/1197802/1197802-hd_1280_720_25fps.mp4" type="video/mp4" />
          <img src="https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=1800&q=85&fit=crop" alt="Construction site" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
        </video>
      </div>
      <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(105deg, rgba(10,22,40,0.65) 0%, rgba(10,22,40,0.35) 55%, rgba(10,22,40,0.2) 100%)' }} />
      <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(180deg, rgba(26,79,156,0.15) 0%, transparent 70%)' }} />
      <div style={{ position: 'absolute', top: 0, right: '35%', width: 2, height: '100%', background: 'linear-gradient(to bottom, transparent, rgba(26,79,156,0.4), transparent)', transform: 'skewX(-15deg)' }} />
      <div className="section-wrap" style={{ position: 'relative', zIndex: 2, width: '100%' }}>
        <div style={{ maxWidth: 680 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.8rem', marginBottom: '1.5rem', opacity: loaded ? 1 : 0, animation: loaded ? 'fadeUp 0.6s ease 0.1s both' : 'none' }}>
            <div style={{ width: 40, height: 2, background: 'var(--blue)' }} />
            <span style={{ fontFamily: "'Barlow Condensed', sans-serif", fontSize: '0.75rem', fontWeight: 700, letterSpacing: '0.32em', textTransform: 'uppercase', color: '#7aaef0' }}>Est. 2007 · RC: 700638 · Nigeria</span>
          </div>
          <h1 style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: 'clamp(2.8rem, 8vw, 8rem)', lineHeight: 0.92, letterSpacing: '0.02em', marginBottom: '1.5rem', opacity: loaded ? 1 : 0, animation: loaded ? 'fadeUp 0.7s ease 0.25s both' : 'none' }}>
            <span style={{ color: 'white', display: 'block' }}>Building</span>
            <span style={{ color: '#7aaef0', display: 'block' }}>Nigeria's</span>
            <span style={{ color: 'white', display: 'block' }}>Infrastructure</span>
          </h1>
          <p style={{ fontFamily: "'Barlow', sans-serif", fontSize: '1.1rem', fontWeight: 300, color: 'rgba(255,255,255,0.72)', lineHeight: 1.75, maxWidth: 500, marginBottom: '2.5rem', borderLeft: '3px solid var(--blue)', paddingLeft: '1.2rem', opacity: loaded ? 1 : 0, animation: loaded ? 'fadeUp 0.7s ease 0.55s both' : 'none' }}>
            Civil engineering, borehole drilling, electrical installations, and general construction — delivered with precision and purpose across Nigeria.
          </p>
          <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap', opacity: loaded ? 1 : 0, animation: loaded ? 'fadeUp 0.7s ease 0.65s both' : 'none' }}>
            <a href="#services" className="btn-primary"><span>Explore Services</span><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M5 12h14M12 5l7 7-7 7"/></svg></a>
            <a href="#projects" className="btn-ghost">View Projects</a>
          </div>
        </div>
        <div style={{ position: 'absolute', bottom: '-12rem', right: 0, display: 'flex', flexDirection: 'column', gap: '1px', opacity: loaded ? 1 : 0, animation: loaded ? 'fadeIn 1s ease 0.8s both' : 'none' }}>
          {[{ num: '18+', label: 'Years' }, { num: '30+', label: 'Experts' }, { num: '4', label: 'Divisions' }].map((s, i) => (
            <div key={i} style={{ background: i === 0 ? 'var(--blue)' : 'rgba(10,22,40,0.85)', backdropFilter: 'blur(8px)', border: '1px solid rgba(26,79,156,0.3)', padding: '1.2rem 2rem', textAlign: 'center', minWidth: 110 }}>
              <div style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: '2.2rem', color: 'white', lineHeight: 1 }}>{s.num}</div>
              <div style={{ fontFamily: "'Barlow Condensed', sans-serif", fontSize: '0.65rem', fontWeight: 600, letterSpacing: '0.2em', color: i === 0 ? 'rgba(255,255,255,0.8)' : 'var(--silver)', textTransform: 'uppercase', marginTop: 2 }}>{s.label}</div>
            </div>
          ))}
        </div>
      </div>
      <button onClick={scrollDown} style={{ position: 'absolute', bottom: '2.5rem', left: '50%', transform: 'translateX(-50%)', background: 'none', border: 'none', cursor: 'pointer', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0.5rem', color: 'rgba(255,255,255,0.4)', fontFamily: "'Barlow Condensed', sans-serif", fontSize: '0.6rem', letterSpacing: '0.25em', textTransform: 'uppercase', animation: 'bounce 2s infinite' }}>
        Scroll
        <div style={{ width: 1, height: 40, background: 'linear-gradient(to bottom, rgba(255,255,255,0.4), transparent)' }} />
      </button>
      <style>{`
        @keyframes bounce { 0%,100% { transform: translateX(-50%) translateY(0); } 50% { transform: translateX(-50%) translateY(8px); } }
        @media (max-width: 900px) { #hero h1 { font-size: clamp(3rem, 11vw, 4.5rem) !important; line-height: 0.95 !important; } }
      `}</style>
    </section>
  );
}
